import React from "react";
import Bartenders from "../pages/Bartenders";
import DiscountManager from "../pages/DiscountManager";
import { Login } from "../pages/auth/Login";
import { SignUp } from "../pages/auth/SignUp";
import ForgetPassword from "../pages/auth/ForgetPassword";
import CheckEmail from "../pages/auth/CheckEmail";
import ResetPassword from "../pages/auth/ResetPasswordSecond";
import BartenderSchedulePage from "../pages/Schedule/BartenderSchedulePage";
import ChangePassword from "../pages/ChangePassword";
import Company from "../pages/company/Company";
import CompaniesList from "../pages/company/Companies";
import PriceCalculation2 from "../pages/company/PriceCalculation2/PriceCalculation";
import EditCompanyPage from "../pages/SuperAdmin/EditCompanyPage";
import EventsPage from "../pages/events/EventsPage";
import { Dashboard } from "../pages/dashboard/DashboardPage";
import { PaymentsPage } from "../pages/payments/PaymentsPage";
import PackagesPage from "../pages/btc/Packages/PackagesPage";
import EditPackageBTC from "../pages/btc/Packages/EditPackageBTC";
import NewPackageBTC from "../pages/btc/Packages/NewPackageBTC";
import CocktailsPage from "../pages/btc/Cocktails/CocktailsPage";
import EditCocktailBTC from "../pages/btc/Cocktails/EditCocktailBTC";
import NewCocktailBTC from "../pages/btc/Cocktails/NewCocktailBTC";
import MyBusiness from "../pages/MyBusiness/MyBusiness";
import AlcohalAndMixers from "../pages/alcohalAndMixers/AlcohalAndMixers";
import QuoteBuilder from "../pages/Quote/QuoteBuilder";
import BillingPage from "../pages/billing/BillingPage";
import EventListPage from "../pages/eventListPage/EventListPage";
import ContractsPage from "../pages/Contracts";
import RewardPointsPage from "../pages/rewardPoints/RewardPointsPage";
import ResourcesPage from "../pages/Resources/ResourcesPage";

export interface AppRoute {
  path: string;
  element: JSX.Element;
}

export const publicRoutes: AppRoute[] = [
  { path: "/signup", element: <SignUp /> },
  { path: "/login", element: <Login /> },
  { path: "/forget/password", element: <ForgetPassword /> },
  { path: "/reset-password", element: <ResetPassword /> },
  { path: "/checkemail", element: <CheckEmail /> },
];

export const privateRoutes: AppRoute[] = [
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/company", element: <CompaniesList /> },
  { path: "/payments", element: <PaymentsPage /> },
  { path: "/events", element: <EventsPage /> },
  { path: "/business", element: <MyBusiness /> },
  { path: "/alcoholandmixers", element: <AlcohalAndMixers /> },
  { path: "/quoteBuilder", element: <QuoteBuilder /> },
  { path: "/quoteBuilder/:id", element: <QuoteBuilder /> },
  { path: "/contracts", element: <ContractsPage /> },
  { path: "/packages", element: <PackagesPage /> },
  { path: "/packages/new", element: <NewPackageBTC /> },
  { path: "/packages/:id", element: <EditPackageBTC /> },
  { path: "/cocktails", element: <CocktailsPage /> },
  { path: "/cocktails/new", element: <NewCocktailBTC /> },
  { path: "/cocktails/:id", element: <EditCocktailBTC /> },
  { path: "/create-company", element: <Company /> },
  { path: "/edit-company/:id", element: <EditCompanyPage /> },
  { path: "/pricecalculator", element: <PriceCalculation2 /> },
  { path: "/billing", element: <BillingPage /> },
  { path: "/reward", element: <RewardPointsPage /> },
  { path: "/resources", element: <ResourcesPage /> },
  { path: "/event", element: <EventListPage /> },
  { path: "/bartenders/schedule", element: <BartenderSchedulePage /> },
  { path: "/", element: <Bartenders /> },
  { path: "/discount", element: <DiscountManager /> },
  { path: "/change-password", element: <ChangePassword /> },
];
